import React from "react";
import { RadioButton } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { getAllowedMagnitudeOptions, offersOnlySmallestMagnitude, resolveNewPrefixChoiceMessageIds, } from "../../utils/newPrefixMagnitude";
/**
 * Block-size choice for a new publisher prefix (FSD PP20). Offers only the sizes the publisher's
 * production allows; when only the smallest one (10) is allowed, an info text replaces the radios.
 */
export var NewPrefixMagnitudeChoice = function (_a) {
    var maxMagnitude = _a.maxMagnitude, allowedMagnitudes = _a.allowedMagnitudes, replacesUsedUpPrefix = _a.replacesUsedUpPrefix, forCoPublisher = _a.forCoPublisher, magnitude = _a.magnitude, onChange = _a.onChange, name = _a.name, fieldsetClassName = _a.fieldsetClassName, hintClassName = _a.hintClassName;
    var formatMessage = useIntl().formatMessage;
    var options = getAllowedMagnitudeOptions(maxMagnitude, allowedMagnitudes);
    var _b = resolveNewPrefixChoiceMessageIds({
        replacesUsedUpPrefix: replacesUsedUpPrefix,
        forCoPublisher: forCoPublisher,
    }), legendId = _b.legendId, onlyTenId = _b.onlyTenId;
    if (offersOnlySmallestMagnitude(options)) {
        return (React.createElement("div", { className: fieldsetClassName },
            React.createElement("p", { className: hintClassName },
                React.createElement(FormattedMessage, { id: onlyTenId }))));
    }
    return (React.createElement("fieldset", { className: fieldsetClassName },
        React.createElement("legend", { className: hintClassName },
            React.createElement(FormattedMessage, { id: legendId })),
        options.map(function (opt) { return (React.createElement(RadioButton, { key: opt.value, label: formatMessage({ id: opt.labelId }, opt.labelValues), name: name, checked: magnitude === opt.value, onChange: function () { return onChange(opt.value); } })); })));
};
